<div style="padding: 24px 20px 40px;">
  <nz-steps
    [nzCurrent]="currentIndex"
    [nzLabelPlacement]="'vertical'"
    class="comps-steps-container"
  >
    <nz-step nzTitle="Start"></nz-step>
    <nz-step nzTitle="Company Selection" class="step-2-title"> </nz-step>
    <nz-step nzTitle="Line Item Selection" class="step-3-title"></nz-step>
    <nz-step nzTitle="Title"></nz-step>
  </nz-steps>
</div>

<div
  [ngSwitch]="currentIndex"
  [ngClass]="{
    'step-1-content': currentIndex === 0,
    'step-2-content': currentIndex === 1,
    'step-3-content': currentIndex === 2
  }"
>
  <app-create-new-comps-base
    *ngSwitchCase="0"
    (setContext)="setContext($event)"
  >
  </app-create-new-comps-base>
  <div *ngSwitchCase="1">
    <app-comps-ticker-modal
      [addRowTableData]="addRowTableData"
      [watchlists]="watchlists"
      [recentlyVisitedCompanies]="recentlyVisitedCompanies"
      maxHeight="250px"
      [mpt]="mpt"
      type="create"
      [isTickerTypeBg]="isTickerTypeBg"
      (tickerUpdate)="onTickerUpdate($event)"
      (mptUpdate)="onMptUpdate($event)"
      maxTickers="50"
    >
    </app-comps-ticker-modal>
  </div>
  <div *ngSwitchCase="2">
    <ng-container *ngIf="context === 'Comparison'; else trendLI">
      <app-line-item-modal
        [addColTableData]="addColTableData"
        [stdLineItems]="stdLineItems"
        [max]="max"
        [createSource]="createSource"
        maxHeight="250px"
        lineItemInputId="createNewCompsWizardLineItemInput"
        [tickers]="tickers"
        [marketItemsData]="marketItemsData"
        (updateComp)="onUpdateComp($event)"
      >
      </app-line-item-modal>
    </ng-container>
    <ng-template #trendLI>
      <app-create-comps-li-modal
        [addColTableData]="addColTableData"
        [stdLineItems]="stdLineItems"
        [createSource]="createSource"
        [max]="max"
        [tickers]="tickers"
        [filterData]="filterData"
        [yearTypeData]="YearTypeData"
        (saveYearType)="updateYearType($event)"
        (saveLineItems)="onUpdateComp($event)"
        [openedForAddIn]="openedForAddIn"
        [marketItemsData]="marketItemsData"
        [periodsWithAvailableDataForPopup]="periodsWithAvailableDataForPopup"
      >
      </app-create-comps-li-modal>
    </ng-template>
  </div>
  <div *ngSwitchCase="3">
    <app-create-new-comps-naming
      [companyData]="addRowTableData"
      [liData]="addColTableData"
      [type]="context"
      [YearTypeData]="YearTypeData"
      (saveCompsName)="updateCompsName($event)"
    ></app-create-new-comps-naming>
  </div>
</div>
